<template>
    <div>
        <slot />
    </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
    mounted() {
        disableBodyScroll(this.scrollEl(), { reserveScrollBarGap: true })
    },

    beforeUnmount() {
        enableBodyScroll(this.scrollEl())
    },

    methods: {
        scrollEl() {
            return this.$el.children[0]
        },
    },
}
</script>
